import React from 'react'

export const WasteAndRecylingIcon = (): JSX.Element => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Redo">
      <path
        id="Vector"
        d="M14.4463 15.57C16.3267 14.0994 17.536 11.8092 17.536 9.23782C17.536 4.80009 13.9501 1.21014 9.51237 1.20411C5.06862 1.19808 1.4646 4.79607 1.4646 9.23782C1.4646 11.753 2.61973 13.997 4.42978 15.4695C4.50009 15.5258 4.60255 15.5137 4.6588 15.4434L5.45031 14.4289C5.50456 14.3606 5.4925 14.2621 5.42621 14.2059C5.26348 14.0733 5.10679 13.9307 4.95612 13.78C4.36875 13.1947 3.9007 12.5008 3.57799 11.7369C3.24049 10.9474 3.07174 10.1057 3.07174 9.23782C3.07174 8.36996 3.24049 7.52822 3.57598 6.7367C3.89942 5.9713 4.36348 5.28424 4.95411 4.69362C5.54473 4.10299 6.23179 3.63893 6.99719 3.31549C7.79072 2.98 8.63246 2.81125 9.50031 2.81125C10.3682 2.81125 11.2099 2.98 12.0014 3.31549C12.7668 3.63893 13.4539 4.10299 14.0445 4.69362C14.6351 5.28424 15.0992 5.9713 15.4226 6.7367C15.7581 7.52822 15.9269 8.36996 15.9269 9.23782C15.9269 10.1057 15.7581 10.9474 15.4226 11.7389C15.0999 12.5028 14.6319 13.1967 14.0445 13.782C13.8577 13.9688 13.6608 14.1436 13.4559 14.3043L12.6383 13.2577C12.6198 13.2338 12.5949 13.2155 12.5665 13.2051C12.5381 13.1947 12.5073 13.1925 12.4777 13.1988C12.4481 13.2051 12.4209 13.2196 12.3992 13.2407C12.3775 13.2618 12.3622 13.2886 12.355 13.3179L11.5595 16.5764C11.5354 16.6769 11.6117 16.7753 11.7142 16.7753L15.0691 16.7914C15.2037 16.7914 15.28 16.6367 15.1956 16.5322L14.4463 15.57Z"
        fill="black"
      />
    </g>
  </svg>
)
